import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Form, Header, Message, Modal } from "semantic-ui-react";
import Comparison from "../../../../../components/Comparison";


import {
    getBrands,
    getCountries,
    getDimensions,
    getProductGroups,
    getProductCategories,
    getProducts,
    getSuppliers,
    isLoading
} from "../../../../../reducer";

import api from "../../../api";

import { getTranslate } from "react-localize-redux/lib/index";

const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};

class Confirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: { ...props.product },
            request: {},
            errors: [],
            sending: false
        };
    }

    sendRequest() {

        const product = this.state.product;

        if (this.state.sending) {
            return;
        }

        // Prevent double sending of requests
        this.setState((state) => {

            if (state.sending === true || state.errors.length > 0) {
                return state;
            }

            let request = this.prepareRequest();

            switch (product.requestType) {
                case "edit":

                    api.updateProduct(product.id, request)
                        .then((status) => {
                            this.complete();
                        })
                        .catch((errors) => {
                            this.setState({ errors }, () => {
                                window.scrollTo(0, 0);
                            });
                        });

                    break;

                case "newVintage":

                    request["siblingID"] = product.productID;

                    api.newVintage(product.id, request)
                        .then((status) => {
                            this.complete();
                        })
                        .catch((errors) => {
                            this.setState({ errors }, () => {
                                window.scrollTo(0, 0);
                            });
                        });

                    break;

                case "create":

                    api.create(request)
                        .then((status) => {
                            this.complete();
                        })
                        .catch((errors) => {
                            this.setState({ errors }, () => {
                                window.scrollTo(0, 0);
                            });
                        });

                    break;

                case "newQuoteProduct":

                    api.newQuoteProduct(request)
                        .then((status) => {
                            this.complete();
                        })
                        .catch((errors) => {
                            this.setState({ errors }, () => {
                                window.scrollTo(0, 0);
                            });
                        });

                    break;

                default:

                    break;
            }

            state.sending = true;
            return state;
        });


    }

    prepareRequest(product = null) {

        if (product === null) {
            product = this.state.product;
        }

        let request = {
            code: product.code,
            code2: product.code2,
            code3: product.code3,
            cost: Number.parseFloat(product.cost, 10),
            priceWithVat: Number.parseFloat(product.priceWithVat, 10),
            price_lists: product.price_lists.map((priceList) => ({
                pricelistID: Number.parseInt(priceList.pricelistID, 10),
                price: Number.parseFloat(priceList.pivot.price, 10),
                id: Number.parseInt(priceList.id, 10),
                name: priceList.name
            })),
            name: product.name,
            manufacturerName: product.manufacturerName,
            supplier_id: Number.parseInt(product.supplier_id, 10),
            vatrate_id: Number.parseInt(product.vatrate_id, 10),
            group_id: Number.parseInt(product.group_id, 10),
            brand_id: Number.parseInt(product.brand_id, 10),
            unitID: Number.parseInt(product.unitID, 10),
            volume: Number.parseInt(product.volume, 10),
            country_id: Number.parseInt(product.country_id, 10),
            description: product.description,
            product_attributes: product.product_attributes.map((attribute) => ({
                name: attribute.name,
                value: attribute.value
            })),
            variations: product.variations.map((variation) => (Number.parseInt(variation.id, 10))),
            comment: product.comment

        };

        if(product.category_id){
            request['category_id'] = Number.parseInt(product.category_id, 10);
        }

        if (product.parent_product) {
            request["parentProductID"] = Number.parseInt(product.parent_product.productID, 10);
        }

        if (request["variations"].length === 0) {
            delete request["variations"];
        }

        if (product.createMatrix === true) {
            request["createMatrix"] = {
                code: product.matrixCode,
                dimension_id_1: 5,
                dimension_id_2: 6,
                dimension_id_3: 7,
                old_product_variation_id_1: Number.parseInt(product.oldProductVariations[0].id, 10),
                old_product_variation_id_2: Number.parseInt(product.oldProductVariations[1].id, 10),
                old_product_variation_id_3: Number.parseInt(product.oldProductVariations[2].id, 10)
            };
        }

        if (product.requestType === "newVintage") {
            request["siblingID"] = Number.parseInt(product.productID, 10);
        }

        return request;

    }


    render() {


        const { translate } = this.props;

        if (this.props.product.requestType === "create" || this.props.product.requestType === "newQuoteProduct") {
            return <div>

                <Header>Overview</Header>

                {this.state.errors.length > 0 &&
                <Message negative header={translate("tools.general.errors.label")}
                         list={this.state.errors}/>
                }

                <Comparison product={this.prepareRequest()}/>


                <ConfirmModal context={this}/>

            </div>;
        } else if (this.props.product.requestType === "newVintage" && this.props.product.createMatrix) {
            const product = { ...this.props.product };
            const oldProduct = { ...this.props.oldProduct };
            oldProduct.variations = [product.oldProductVariations[0].id, product.oldProductVariations[1].id, product.oldProductVariations[2].id];

            return <div>

                <Header>Overview</Header>

                {this.state.errors.length > 0 &&
                <Message negative header={translate("tools.general.errors.label")}
                         list={this.state.errors}/>
                }

                <Comparison product={this.prepareRequest()}
                            comparison={this.prepareRequest(oldProduct)}/>


                <ConfirmModal context={this}/>

            </div>;

        }

        return <div>

            <Header>Overview</Header>

            {this.state.errors.length > 0 &&
            <Message negative header={translate("tools.general.errors.label")}
                     list={this.state.errors}/>
            }

            <Comparison product={this.prepareRequest()}
                        comparison={this.prepareRequest(this.props.oldProduct)}/>


            <ConfirmModal context={this}/>


        </div>;
    }

    complete() {
        this.props.onComplete(this.state.product);
    }


}

const ConfirmModal = ({ context }) => {
    return <div>
        {context.state.errors.length === 0 ?

            <Modal style={inlineStyle.modal}
                   trigger={<Button fluid size='big' positive type='button'>Next</Button>}>
                <Modal.Header>{context.props.translate("tools.fields.confirm")}</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form
                            onSubmit={() => {
                                context.sendRequest();
                            }}
                        > <Form.Field required
                                      label={context.props.translate("tools.manageRequests.fields.comment")}
                                      control='textarea' rows='3'
                                      value={context.state.product.comment ? context.state.product.comment : ""}
                                      onChange={(e) => {
                                          context.setState({
                                              product: {
                                                  ...context.state.product,
                                                  comment: e.target.value
                                              },
                                          });
                                      }}
                                      placeholder={context.props.translate("tools.manageRequests.fields.comment")}/>
                            {context.state.product.comment && context.state.product.comment.length > 0 &&
                            <Button fluid
                                    positive>{context.props.translate("tools.fields.send")}</Button>}
                        </Form>
                    </Modal.Description>
                </Modal.Content>
            </Modal>

            : ""

        }
    </div>;
};

Confirmation.propTypes = {
    onComplete: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    oldProduct: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    isLoading: isLoading(state.tools),
    dimensions: getDimensions(state.tools),
    productGroups: getProductGroups(state.tools),
    productCategories: getProductCategories(state.tools),
    products: getProducts(state.tools),
    suppliers: getSuppliers(state.tools),
    countries: getCountries(state.tools),
    brands: getBrands(state.tools)
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Confirmation);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/Confirmation/index.js